import React from 'react';
import SelectedContactDisplay from 'src/components/SelectedContactDisplay/SelectedContactDisplay';
import { CanonicalContact } from 'src/pages/ServiceRequest/ContactPicker/helpers/contactShape';
import { IServiceRequest } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import AssignConfirmationRow from './AssignConfirmationRow/AssignConfirmationRow';
import {
  ScrollEndGate,
  useScrollEndGate,
} from './CustomHooks/useScrollEndGate';
import './assign-confirmation-review.scss';

interface AssignConfirmationReviewProps {
  serviceRequests: IServiceRequest[];
  selectedContact: CanonicalContact | null;
}

export const AssignConfirmationReview = ({
  serviceRequests,
  selectedContact,
}: AssignConfirmationReviewProps) => {
  const scrollGate: ScrollEndGate = useScrollEndGate();

  const requestCount: number = serviceRequests.length;
  const requestCountLabel: string =
    requestCount === 1 ? '1 service request' : `${requestCount} service requests`;
  const listShellClassName: string = scrollGate.hasReachedEnd
    ? 'assign-confirmation-review-list-shell is-reviewed'
    : 'assign-confirmation-review-list-shell';

  return (
    <div className="assign-confirmation-review">
      <div className="assign-confirmation-review-provider">
        <p className="assign-confirmation-review-provider-label">
          Assigning to
        </p>
        <SelectedContactDisplay
          contact={selectedContact}
          subtitleVariant="role-and-services"
          readOnly
        />
      </div>

      <p className="assign-confirmation-review-count">
        You are about to reassign <strong>{requestCountLabel}</strong>.
      </p>

      <div className={listShellClassName}>
        <div
          className="assign-confirmation-review-list"
          ref={scrollGate.scrollRef}
          onScroll={scrollGate.onScroll}
        >
          {serviceRequests.map((serviceRequest: IServiceRequest) => (
            <AssignConfirmationRow
              key={serviceRequest.id}
              serviceRequest={serviceRequest}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssignConfirmationReview;